import React from 'react';

const Footer = () => {
  return(
    <footer>
      <div className="pull-right">
        Trang web hiện thị tốt nhất trên trình duyệt <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Google Chrome</a>!
      </div>
      <div className="clearfix"></div>
    </footer>
  );
}
export default Footer;
